var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondSolanaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 123,
    viewBox: "0 0 124 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solana"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse",
    filter: "url(#filter0_f_1877_14960)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5666,
    cy: 23.0259,
    rx: 23.5666,
    ry: 23.0259,
    transform: "matrix(0.979197 -0.202913 0.213022 0.977047 34 43.5625)",
    fill: "#28FFCD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M47.763 54.2573C47.8593 54.0745 48.0325 53.9445 48.2358 53.9024L72.8075 48.8105C73.3809 48.6917 73.8449 49.2861 73.5863 49.8082L70.1483 56.7493C70.054 56.9398 69.877 57.0762 69.6678 57.1195L44.851 62.2621C44.2697 62.3826 43.8048 61.7717 44.08 61.2492L47.763 54.2573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    d: "M51.9622 73.5385C52.0585 73.3558 52.2317 73.2258 52.435 73.1836L77.0067 68.0918C77.5801 67.973 78.0441 68.5673 77.7855 69.0894L74.3476 76.0306C74.2532 76.2211 74.0762 76.3574 73.867 76.4008L49.0502 81.5434C48.4689 81.6638 48.004 81.053 48.2793 80.5304L51.9622 73.5385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    d: "M51.678 70.6608C51.8425 70.7914 52.0565 70.8426 52.2612 70.8001L76.5203 65.7731C77.0918 65.6547 77.2691 64.9314 76.8188 64.5555L70.84 59.5658C70.674 59.4273 70.4539 59.3718 70.2433 59.4155L45.7422 64.4927C45.1628 64.6128 44.9914 65.3514 45.4571 65.7212L51.678 70.6608Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_14960",
    x: 0.482811,
    y: 0.373436,
    width: 122.995,
    height: 121.808,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.95,
    result: "effect1_foregroundBlur_1877_14960"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondSolanaIcon);
export default __webpack_public_path__ + "static/media/SecondSolanaIcon.ccffddb5efba03ef39ac7effa5e7f132.svg";
export { ForwardRef as ReactComponent };